import { ButtonProps } from "@chakra-ui/react";

import { colors } from "src/colors";

export type ButtonVariantType =
  | "primary"
  | "secondary"
  | "primaryBlack"
  | "secondaryBlack"
  | "outlineWhite";

const disabledProps = {
  cursor: "auto"
};

export const BUTTONS_THEMES: { [key in ButtonVariantType]: ButtonProps } = {
  primary: {
    color: colors.white.off,
    bg: colors.orange[400],
    borderColor: colors.orange[400],

    _hover: {
      bg: colors.orange[200],
      borderColor: colors.orange[200]
    },

    _active: {
      bg: colors.green[900],
      borderColor: colors.green[900]
    },

    _disabled: {
      ...disabledProps,
      bg: colors.orange[100],
      borderColor: colors.orange[100],
      _hover: {
        bg: colors.orange[100],
        borderColor: colors.orange[100]
      }
    }
  },

  secondary: {
    color: colors.orange[400],
    bg: "transparent",
    borderColor: colors.orange[400],

    _hover: {
      color: colors.white.off,
      bg: colors.orange[200],
      borderColor: colors.orange[200]
    },

    _active: {
      color: colors.white.off,
      bg: colors.orange[400],
      borderColor: colors.orange[400]
    },

    _disabled: {
      ...disabledProps,
      color: colors.orange[100],
      borderColor: colors.orange[100],

      _hover: {
        bg: "transparent",
        color: colors.orange[100],
        borderColor: colors.orange[100]
      }
    }
  },

  primaryBlack: {
    color: colors.white.off,
    bg: colors.black[900],
    borderColor: colors.black[900],

    _hover: {
      bg: colors.black[800],
      borderColor: colors.black[800]
    },

    _active: {
      bg: colors.black[600],
      borderColor: colors.black[600]
    },

    _disabled: {
      ...disabledProps,
      bg: colors.grey[400],
      borderColor: colors.grey[400],

      _hover: {
        bg: colors.grey[400],
        borderColor: colors.grey[400]
      }
    }
  },

  secondaryBlack: {
    bg: "transparent",
    color: colors.black[900],
    borderColor: colors.black[900],

    _hover: {
      color: colors.white.off,
      bg: colors.black[800],
      borderColor: colors.black[800]
    },

    _active: {
      color: colors.white.off,
      bg: colors.black[900],
      borderColor: colors.black[900]
    },

    _disabled: {
      ...disabledProps,
      color: colors.grey[400],
      borderColor: colors.grey[400],

      _hover: {
        bg: "transparent",
        color: colors.grey[400],
        borderColor: colors.grey[400]
      }
    }
  },

  outlineWhite: {
    color: colors.white.off,
    bg: colors.orange[400],
    borderWidth: 1,
    borderColor: colors.white.default,

    _hover: {
      bg: colors.orange[200],
      borderColor: colors.orange[200]
    },

    _active: {
      bg: colors.green[900],
      borderColor: colors.green[900]
    },

    _disabled: {
      ...disabledProps,
      bg: colors.orange[100],
      borderColor: colors.orange[100],
      _hover: {
        bg: colors.orange[100],
        borderColor: colors.orange[100]
      }
    }
  }
};
